import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class ActivitylogService {
  baseUrl: string = environment.serviceUrl;
  constructor(private httpClient: HttpClient) { }

  getActivityLog(type: string, pagenumber: number, itemsperpage: number, searchCondition, sortCondition): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/ActivityLogApi/GetActivityLog?type=' + type + '&&pageno=' + pagenumber + '&&itemsperpage=' + itemsperpage)
  }

  getActivityLogCount(type: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/ActivityLogApi/GetActivityLogCount?type=' + type);
  }

  getActivityLogData(requestData) {
    return this.httpClient.post<any>(this.baseUrl + 'api/ActivityLogApi/GetActivityLogData', requestData, { headers: header, observe: 'response' });
  }

}
